// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"oy_a big_a big_x","FilterForm__vgroup":"oy_b big_sv"};